module.exports = __webpack_public_path__ + "img/0c0d49e6d3b39049cab1de18d5948f8a.png";